// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/insurance-payment-report/components/insurance-payment-header/insurance-payment-header.less
// module id = 3911
// module chunks = 0